/* © CNES */
import { InputText } from 'primereact/inputtext';
import { useContext, useEffect, useState } from 'react';
import Floater from 'react-floater';
import { ConfigContext } from '../../../context/ConfigContext';
import { FilterDataContext } from '../../../context/FilterDataContext';
import { DATASET, IDENTIFIER } from '../../shared/Constants';
import {
  StartGuidContent,
  startGuidStyle,
} from '../../shared/startGuidContent/StartGuidContent';
import './SearchContainer.scss';

/**
 * SearchContainer To display search bar for thesaurus and regards elements.
 * @returns SearchContainer Element.
 */
export const SearchContainer = ({
  displayToast,
}: {
  displayToast: Function;
}) => {
  const { filterData, setFilterData } = useContext(FilterDataContext);
  const [searchValue, setSearchValue] = useState<string | null>(null);
  const { setQueryPage, isGetStarted } = useContext(ConfigContext);

  useEffect(() => {
    setSearchValue(filterData[IDENTIFIER] as string);
  }, [filterData]);

  /**
   * add search string to filter properties.
   */
  const addSearchString = () => {
    if (filterData[DATASET] === null) {
      displayToast(
        'info',
        'Requested action',
        'Select a Collection in the Filters panel to see results.'
      );
    }

    // Reset page to 1 when search is applied
    setQueryPage(1);
    setFilterData({
      ...filterData,
      [IDENTIFIER]: searchValue?.length ? searchValue : null,
    });
  };

  return (
    <>
      <Floater
        open={isGetStarted}
        content={
          <StartGuidContent
            title="Semantic search"
            body="Refine your search with a string contained in the product's name: <br/>A tile, a date, a location, ... <br/><br/>Tip: make sure at least one mission is selected first!"
            icon="search.png"
          />
        }
        placement={'auto'}
        offset={-10}
        target={'.searchInputFloater'}
        styles={{
          ...startGuidStyle,
          ...{ floater: { left: 200 } },
          ...{
            container: {
              backgroundColor: '#113268',
              borderRadius: 5,
              color: '#fff',
              filter: 'none',
              minHeight: 'none',
              padding: 15,
              minWidth: 250,
              width: 290,
            },
          },
        }}
      />
      <span aria-label="searchBar" className="searchBar">
        <span className="p-input-icon-left inputContainer">
          <i className="pi pi-search" />
          <InputText
            aria-label="searchInput"
            id="inputSearch"
            className="searchInputFloater"
            value={searchValue || ''}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Search by a part of product name, ex : T31TCJ"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                addSearchString();
              }
            }}
          />
        </span>
      </span>
    </>
  );
};
